import { Box, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  width: 100%;
  flex-wrap: wrap;
  gap: ${({ theme }) => getThemeSpacing(6, theme)};
  row-gap: ${({ theme }) => getThemeSpacing(1, theme)};
`
